import { Star } from '@mui/icons-material';
import Acent from 'components/Acent';
import Tag from 'components/Tag';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import TextEditor from 'components/TextEditor';
import SubdirectoryArrowLeftIcon from '@mui/icons-material/SubdirectoryArrowLeft';

const EditStudentAnswer = ({ states, funcObj }) => {
  const showAlert = useAlert();
  const textareaCommentRef = useRef();
  const { editSubtitle, num, subtitle } = states;
  const { handleSubmitSubtitle } = funcObj;
  const [isFocused, setIsFocused] = useState(false);
  const [subtitleText, setSubTitleText] = useState('');

  useEffect(() => {
    if (subtitle) {
      setSubTitleText(subtitle);
    }
  }, [subtitle]);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (e.target.value?.length === 0) {
        showAlert('Please enter a comment before submitting.', 'error');
        return;
      }
      handleSubmitSubtitle(e.target.value, num);
    }
  }

  return (
    <>
      {editSubtitle?.index === num && (
        <div className='flex-1'>
          <div className="flex items-center mt-10px widgetNote">
            <Tag height={20}>
              <Star
                style={{
                  height: '12px',
                  margin: '-1px 4px 0px 0px',
                  width: '12px',
                }}
              />
              NOTE
            </Tag>

            <Note>Press Enter to save and see the updated message.</Note>
          </div>
          <div>
            <InputContainer isFocused={isFocused}>
                <TextEditor
                ref={textareaCommentRef}
                placeholder="Write a reply..."
                value={subtitleText}
                handleChange={setSubTitleText}
                onKeyDown={handleKeyDown}
                  />
              {/* <Acent
                inputRef={textareaCommentRef}
                setValue={setSubTitleText}
                style={{
                  marginBottom: 42,
                  display: 'flex',
                  justifyContent: 'flex-end',
                  position: 'inherit',
                }}
              /> */}
              <SendButton
                onClick={() => {
                  if (subtitleText?.length === 0) {
                    showAlert('Please enter a comment before submitting.', 'error');
                    return;
                  }
                  handleSubmitSubtitle(subtitleText, num);
                }}
              >
                <div className="debateArrowIconWrapper">
                    <SubdirectoryArrowLeftIcon sx={{color: "#000"}} className="debateArrowIcon" />
                  </div>
              </SendButton>
            </InputContainer>
          </div>
        </div>
      )}
    </>
  );
};

export default EditStudentAnswer;

const Note = styled.span`
  color: #000;
  display: block;
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
`;

const SendButton = styled.button`
  background: transparent;
  border: none;
  color: #1877f2;
  font-size: 25px;
  cursor: pointer;
  // position: absolute;
  bottom: 8px;
  right: 10px;

  &:disabled {
    color: #ccc;
    cursor: not-allowed;
  }
`;

const InputContainer = styled.div`
  flex: 1;
  // position: relative;
  background-color: white;
  border-radius: 18px;
  padding: 8px 12px;
  display: flex;
  align-items: flex-end;
  transition: all 0.2s ease-in-out;
  margin-bottom: 10px;
  @media Screen and (max-width: 390px) {
    max-width: 80%;
  }
  &:
    hover,
    ${({ isFocused }) =>
      isFocused &&
      `
    box-shadow: 0 0 0 1px #ccc;
    background-color: #fff;
  `};
`;

const StyledTextarea = styled.textarea`
  flex: 1;
  resize: none;
  border: none;
  background: transparent;
  font-size: 14px;
  // padding-right: 30px;
  min-height: 24px;
  max-height: 150px;
  overflow-y: auto;

  &:focus {
    outline: none;
  }
`;
